<app-admin-maintenance-banner></app-admin-maintenance-banner>
<app-maintenance *ngIf="showMaintenancePage"></app-maintenance>
<router-outlet *ngIf="showNormalApp"></router-outlet>
<app-premium-hint></app-premium-hint>
<app-whats-new *ngIf="showNormalApp"></app-whats-new>
